import { SHOW_MODAL, HIDE_MODAL } from '@/state/types/modal'

export function showModal(payload) {
  return { type: SHOW_MODAL, payload }
}

export function hideModal(...args) {
  return { type: HIDE_MODAL }
}



// WEBPACK FOOTER //
// ./state/actions/modal.js